module.exports = __webpack_public_path__ + "static/img/fas_banner.a673e25.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/fas_banner.jpg
// module id = 45
// module chunks = 1